<template>
  <div class="modal personal-info-modal">
    <div class="overlay" @click="$parent.closePersonalInfoModal"></div>
    <div class="wrapper">
      <div class="container">
        <img
          class="close"
          @click="$parent.closePersonalInfoModal"
          src="./../images/close.svg"
        />
        <ValidationObserver
          ref="form"
          slim
          v-slot="{ handleSubmit, valid, pristine }"
        >
          <form @submit.prevent="submit" class="form-container">
            <div class="overflow">
              <div class="form">
                <div class="title small">
                  {{ $t("Edit profile") }}
                </div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  vid="name"
                  slim
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("Name") }}:</b>
                    </div>
                    <input required v-model="name" name="name" type="text" />
                    <div v-if="errors.length" class="error">
                      {{ errors[0] }}
                    </div>
                  </label>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  vid="surname"
                  slim
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("Surname") }}:</b>
                    </div>
                    <input
                      required
                      v-model="surname"
                      name="surname"
                      type="text"
                    />
                    <div v-if="errors.length" class="error">
                      {{ errors[0] }}
                    </div>
                  </label>
                </ValidationProvider>
                <ValidationProvider
                  rules="required|email"
                  v-slot="{ errors }"
                  vid="email"
                  slim
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("E-mail") }}:</b>
                    </div>
                    <input required v-model="email" name="email" type="text" />
                    <div v-if="errors.length" class="error">
                      {{ errors[0] }}
                    </div>
                  </label>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  vid="phone"
                  slim
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("Phone") }}:</b>
                    </div>
                    <input required v-model="phone" name="phone" type="text" />
                    <div v-if="errors.length" class="error">
                      {{ errors[0] }}
                    </div>
                  </label>
                </ValidationProvider>
              </div>
              <div class="buttons center">
                <button
                  :disabled="!valid && !pristine"
                  type="submit"
                  class="button colored"
                >
                  {{ $t("Save changes") }}
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import axios from "@/axios";

export default {
  name: "PersonalInfoModal",
  props: [],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    this.phone = this.profile.phone || "";
    this.email = this.profile.email || "";
    this.name = (this.profile.name || "").trim();
    this.surname = (this.profile.surname || "").trim();
  },
  data: function () {
    return {
      name: "",
      surname: "",
      phone: "",
      email: "",
    };
  },
  methods: {
    submit() {
      const self = this;

      axios
        .put("user/profile", {
          name: this.name,
          surname: this.surname,
          email: this.email,
          phone: this.phone,
        })
        .then(({ data }) => {
          if (data.status === "OK") {
            self.SET_PROFILE({
              ...self.profile,
              name: self.name,
              surname: self.surname,
              email: self.email,
              phone: self.phone,
            });
            self.$parent.closePersonalInfoModal();
          } else if (data.errors) {
            this.$refs.form.setErrors(data.errors);
          }
        })
        .catch(async ({ response }) => {
          if (response.data.errors) {
            this.$refs.form.setErrors(response.data.errors);
          }
        });
    },
    ...mapMutations("user", ["SET_PROFILE"]),
  },
  computed: {
    ...mapGetters("user", ["profile"]),
  },
};
</script>
